import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {ListService} from "@/services/list-service";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import {Quality} from "@/store/player/types";

export class QualityPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, curr: Quality, callback: (quality: Quality) => unknown) {
        super(scene, canvas, ' ' + Tr('qi'));
        this.setDepth(ListService.DEPTH + 1);

        let blockFirst = TextUtils.addTextAdvanced(scene, Tr('qi.set'), 0, -130,
            '#ffffff', 13, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_REGULAR);
        this.add(blockFirst);


        let blockSecond = TextUtils.addTextAdvanced(scene, Tr('nd.re'), 0, 0,
            '#dcdbdb', 14, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_REGULAR);
        this.add(blockSecond);

        this.addButt(Quality.LOWEST, curr, -150, 150, callback);
        this.addButt(Quality.LOW, curr, -50, 150, callback);
        this.addButt(Quality.STANDARD, curr, 50, 150, callback);
        this.addButt(Quality.HIGH, curr, 150, 150, callback);
    }

    private addButt(qa: Quality, pickedOption: Quality, x: number, y: number, callback: (quality: Quality) => unknown) {
        SpriteUtils.scale(this.addCustomButton(x, y, QualityPanel.toString(qa), Keys.UI_ART_BROWN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => callback(qa)), 0.7 / CU.S, 0.7 / CU.S)
            .setAlpha(qa === pickedOption ? 0.3 : 1);
    }

    private static toString(qa: Quality): string {
        switch (qa) {
            case Quality.LOWEST:
                return Tr('q.lst');
            case Quality.LOW:
                return Tr('q.lw');
            case Quality.STANDARD:
                return Tr('q.st');
            case Quality.HIGH:
                return Tr('q.hg');
        }
        return '';
    }
}
